import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Button, Col, TextBody } from '../../atoms';
export function CollapsibleText({ message, openText = 'Read full disclaimer', closeText = 'Close disclaimer', maxLines = 4, }) {
    const [expanded, setExpanded] = useState(false);
    const [measuredHeight, setMeasuredHeight] = useState(0);
    const [collapsedHeight, setCollapsedHeight] = useState(0);
    const animatedHeight = useRef(new Animated.Value(0)).current;
    const onFullTextLayout = useCallback((e) => {
        const height = e.nativeEvent.layout.height;
        setMeasuredHeight(height);
    }, []);
    const onCollapsedTextLayout = useCallback((e) => {
        const height = e.nativeEvent.layout.height;
        setCollapsedHeight(height);
        animatedHeight.setValue(height);
    }, [animatedHeight]);
    const toggle = useCallback(() => {
        Animated.timing(animatedHeight, {
            toValue: expanded ? collapsedHeight : measuredHeight,
            duration: 500,
            useNativeDriver: false,
        }).start();
        setExpanded(!expanded);
    }, [animatedHeight, collapsedHeight, expanded, measuredHeight]);
    return (_jsxs(Col.L, { children: [_jsx(TextBody, { style: [$.hidden, { zIndex: -1 }], onLayout: onFullTextLayout, children: message }), _jsx(TextBody, { style: [$.hidden, { zIndex: -1 }], numberOfLines: maxLines, onLayout: onCollapsedTextLayout, children: message }), _jsx(Animated.View, { style: { height: animatedHeight, overflow: 'hidden' }, children: _jsx(TextBody, { children: message }) }), _jsx(Button, { variant: "tertiary", size: "sm", onPress: toggle, style: $.toggle, label: expanded ? closeText : openText })] }));
}
const $ = StyleSheet.create({
    toggle: {
        marginTop: theme.spacing['4'],
    },
    hidden: {
        position: 'absolute',
        opacity: 0,
        // @ts-expect-error This is web only. This is necessary because on web, despite absolute position, the expanded hidden block pushes page bottom, inflating the footer
        transform: 'translateY(-100%)',
    },
});
